import * as React from "react";

function SvgSearch16Px(props) {
  return <svg width={15} height={15} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-.523 4.89a6 6 0 1 1 1.414-1.414l3.816 3.817a1 1 0 0 1-1.414 1.414l-3.816-3.816z" fill="currentColor" /></svg>;
}

export default SvgSearch16Px;